import type { ClientEnrichedCircular } from "~/routes/api.circulars";
import { search } from "~/utils/search";

import type { CircularType } from "@vy-clients/document-distribution";
import { differenceInDays } from "date-fns";

export type CircularFilter = {
  query?: string;
  types: CircularType[];
  isRecipient?: boolean;
};

export const filterCirculars = ({
  circulars,
  filter,
}: {
  circulars: ClientEnrichedCircular[];
  filter: CircularFilter | undefined;
}) => {
  if (!filter) {
    return circulars;
  }
  const { types, isRecipient, query } = filter;

  let filteredCirculars = circulars;
  if (query) {
    filteredCirculars = circulars.filter(
      search(query, (it) => [it.circularId, it.title]),
    );
  }

  if (types.length) {
    filteredCirculars = filteredCirculars.filter((circular) =>
      types.includes(circular.type),
    );
  }

  if (isRecipient === true) {
    filteredCirculars = filteredCirculars.filter(
      (circular) => circular.isRecipient,
    );
  } else if (isRecipient === false) {
    filteredCirculars = filteredCirculars.filter(
      (circular) => !circular.isRecipient,
    );
  }

  return filteredCirculars;
};

// Number of days to keep acknowledged circulars in order control.
export const NUMBER_OF_DAYS_TO_KEEP_IN_ORDER_CONTROL = 7;

export const filterAcknowledgedLongAgo = (
  circulars: ClientEnrichedCircular[],
): ClientEnrichedCircular[] => {
  const now = new Date();
  return circulars.filter((circular) => {
    const timestamp =
      circular.circularAck?.confirmedUnderstoodAt ??
      circular.circularAck?.confirmedReceivedAt;
    if (timestamp) {
      const date = new Date(timestamp);
      return (
        differenceInDays(now, date) <= NUMBER_OF_DAYS_TO_KEEP_IN_ORDER_CONTROL
      );
    } else {
      console.warn(
        `Found no ack timestamps in circular ${JSON.stringify(
          circular,
        )} - this should not happen for a list of acknowledged circulars. Filtering out.`,
      );
      return false;
    }
  });
};
